import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress } from '@material-ui/core';
import { Auth } from 'aws-amplify';
import { AlertContext } from '../../shared/app/AlertProvider';
import i18nInstance from '../../../translations';
import AuthService from '../../../services/AuthService';

const Logout = () => {
  const [redirect, setRedirect] = useState(false);

  const { showAlert } = useContext(AlertContext);

  const { t } = useTranslation();

  useEffect(() => {
    Auth.signOut();
    // @ts-ignore next
    i18nInstance.removeSettings();
    AuthService.removeAuthFromStorage();
    AuthService.removeFromStorage('PRODUCT_RECOMMENDATION');
    showAlert({
      severity: 'success',
      message: t('Logout.successMsg'),
    });
    setRedirect(true);
  }, [showAlert, t]);

  if (redirect) {
    return <Redirect to="/login" />;
  }

  return (
    <main>
      <Helmet>
        <title>
          {t('Logout.label')} | {process.env.REACT_APP_NAME}
        </title>
      </Helmet>

      <Box
        display="flex"
        flex={1}
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    </main>
  );
};

export default Logout;
